import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { Helmet } from "react-helmet-async";
import { Button, Card, ErrorText, Input, Label } from "../components/ui";
import { useAuthStore } from "../stores/authStore";
import { api } from "../services/api";

const attachSchema = z.object({
  adminToken: z.string().uuid(),
});

export function Profile() {
  const { user, loading } = useAuthStore();
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  const f = useForm<z.infer<typeof attachSchema>>({ resolver: zodResolver(attachSchema) });

  if (loading) return <p className="text-slate-400">…</p>;
  if (!user) return <Navigate to="/auth/login" replace />;

  const attach = f.handleSubmit(async (v) => {
    setErr("");
    setMsg("");
    try {
      await api.post("/auth/attach-wishlist", v);
      setMsg("Список привязан к аккаунту.");
      f.reset();
    } catch (e: unknown) {
      const m =
        typeof e === "object" && e && "response" in e
          ? String((e as { response?: { data?: { error?: { message?: string } } } }).response?.data?.error?.message)
          : "";
      setErr(m || "Не удалось привязать");
    }
  });

  return (
    <>
      <Helmet>
        <title>Профиль — WishList Hub</title>
      </Helmet>
      <div className="space-y-6 max-w-lg">
        <Card>
          <h1 className="text-xl font-semibold text-white">Профиль</h1>
          <p className="mt-2 text-slate-400">{user.name}</p>
          <p className="text-sm text-slate-500">{user.email}</p>
        </Card>
        <Card>
          <h2 className="font-semibold text-white">Привязать гостевой список</h2>
          <p className="mt-1 text-sm text-slate-500">
            Вставьте admin token из адресной строки (часть после /admin/)
          </p>
          <form className="mt-4 space-y-3" onSubmit={attach}>
            <div>
              <Label>Admin token (UUID)</Label>
              <Input {...f.register("adminToken")} placeholder="550e8400-e29b-41d4-a716-446655440000" />
            </div>
            {err && <ErrorText>{err}</ErrorText>}
            {msg && <p className="text-sm text-emerald-400">{msg}</p>}
            <Button type="submit">Привязать</Button>
          </form>
        </Card>
      </div>
    </>
  );
}
